module.exports = __webpack_public_path__ + "img/artboard2.da7adcc4.png";